import {tva} from "@gluestack-ui/nativewind-utils/tva";

export const alertStyle = tva({
    base: "min-h-[auto]",

    variants: {
        action: {
            error: "",
            warning: "",
            success: "",
            info: "",
            muted: ""
        },

        variant: {
            banner: "border-b border-solid py-3 px-6 flex-row gap-2",
            subtle: "p-0 bg-transparent border-b-0 gap-1.5",
            solid: "py-2 px-3 bg-transparent border-b-0 gap-2 rounded-lg"
        }
    },
    compoundVariants: [
        {
            action: "error",
            variant: ["solid", "banner"],
            class: "bg-error-50 border-b-error-300"
        },
        {
            action: "warning",
            variant: ["solid", "banner"],
            class: "bg-amber-50 border-b-amber-300"
        },
        {
            action: "success",
            variant: ["solid", "banner"],
            class: "bg-success-50 border-b-success-300"
        },
        {
            action: "info",
            variant: ["solid", "banner"],
            class: "bg-blue-50 border-b-blue-300"
        },
        {
            action: "muted",
            variant: ["solid", "banner"],
            class: "bg-blueGray-50 border-b-blueGray-300"
        }
    ]
});

export const alertTextStyle = tva({
    base: "",
    variants: {},
    parentVariants: {
        action: {
            error: "text-error-600",
            warning: "text-amber-500",
            success: "text-success-600",
            info: "text-blue-600",
            muted: "text-blueGray-600"
        }
    }
});

export const alertIconStyle = tva({
    base: "",
    variants: {},
    parentVariants: {
        variant: {
            subtle: "mt-0.5",
            solid: ""
        },
        action: {
            error: "fill-error-600",
            warning: "fill-amber-500",
            success: "fill-success-600",
            info: "fill-blue-600",
            muted: "fill-blueGray-600"
        }
    }
});

export const iconWrapperOutsideStyle = tva({
    base: "h-10 w-10 shrink-0 grow-0 rounded-full border-2 border-solid",
    variants: {
        action: {
            muted: "border-blueGray-600/10",
            success: "border-alert-success-text/10",
            warning: "border-alert-warning-text/10",
            error: "border-alert-error-text/10",
            info: "border-alert-info-text/10"
        }
    }
});

export const iconWrapperInsideStyle = tva({
    base: "h-7 w-7 rounded-full border-2 border-solid",
    variants: {
        action: {
            muted: "border-blueGray-600/30",
            success: "border-alert-success-text/30",
            warning: "border-alert-warning-text/30",
            error: "border-alert-error-text/30",
            info: "border-alert-info-text/30"
        }
    }
});

export const alertContainerStyle = tva({
    base: "w-full align-start justify-between",
    variants: {
        variant: {
            solid: "gap-3",
            banner: "gap-3",
            subtle: "gap-2"
        }
    }
});
